<script lang="ts">
    export let event
</script>

{#if event.date}
    <h3>{event.date}</h3>
{:else if event.start}
    <div class="event">
        <div class="event-time">
            <span class="time">{event.start}</span>
        </div>

        {#if event.url}
            <a class="event-details" href="{event.url}" title="{event.name}">
                <span class="name">{event.name}</span>
                {#if event.image}
                    <img src="{globalThis.config.baseUrl + event.image}" alt="{event.name}">
                {/if}
            </a>
        {:else}
            <div class="event-details">
                <span class="name">{event.name}</span>
                {#if event.image}
                    <img src="{globalThis.config.baseUrl + event.image}" alt="{event.name}">
                {/if}
            </div>
        {/if}
        <div class="clear"></div>
    </div>
{:else if event.error}
    <p>{event.error}</p>
{/if}